module.exports = __webpack_public_path__ + "img/font_img.d0ff4603.png";